var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JoszakiCard',{staticClass:"OnlineCoverageBanner",attrs:{"type":"primary-alt"}},[_c('p',{staticClass:"flex flex-row items-center gap-2 text-sm md:text-base"},[_c('IconComponent',{staticClass:"text-primary-light shrink-0",attrs:{"icon":"globe"}}),_c('span',[_vm._v(_vm._s(_vm.$t("personProfile.location.onlineCoverage.listing")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }